import React, { useMemo, useState } from "react";
import { CustomDatePicker } from "../CustomDatePicker/CustomDatePicker";
import { BottomSheet } from "../BottomSheet/BottomSheet";
import { DateInputFieldProps } from "./DateInputField.types";
import { colorPalette } from "../../theme/colors";
import { VerticalSpacer } from "../../primitives/Spacer/VerticalSpacer";
import { InputField } from "../InputField/InputField";
import FlexRow from "../Layout/FlexRow/FlexRow";
import { Heading2SemiboldTypography } from "../../primitives/Typography/typographyVariants";

export const DateInputField: React.FC<DateInputFieldProps> = ({
  value, // Set default value to "DD/MM/YYYY"
  onChange,
  label,
  variant = "default",
  helpText,
  isRequired = false,
  onBlur,
  bottomSheetTitle,
  onOpen,
}) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const handleInputClick = () => {
    if (onOpen) onOpen();
    setIsDatePickerOpen(true);
  };
  const initialDate = useMemo(() => {
    if (!value || value === "DD/MM/YYYY") return undefined;

    const [day, month, year] = value
      .split("/")
      .map((num) => Number.parseInt(num, 10));

    const date = new Date(year, month - 1, day);

    return isNaN(date.getTime()) ? undefined : date;
  }, [value]);

  const handleDateSelect = (selectedDate: string) => {
    const date = new Date(selectedDate);
    const formattedDate = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date
      .getDate()
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
    onChange(formattedDate);
  };

  const handleClose = () => {
    setIsDatePickerOpen(false);
  };

  return (
    <>
      <InputField
        type="text"
        value={value}
        label={label}
        variant={variant}
        helpText={helpText}
        isRequired={isRequired}
        showCrossButton={false}
        onChange={() => {}}
        onBlur={onBlur}
        onClick={handleInputClick}
        readOnly
      />

      <BottomSheet
        open={isDatePickerOpen}
        handleClose={handleClose}
        disableDragClose={true}
      >
        <FlexRow py="small">
          <Heading2SemiboldTypography
            fontFamily="Lexend"
            color={colorPalette.popBlack[500]}
          >
            {bottomSheetTitle}
          </Heading2SemiboldTypography>
        </FlexRow>
        <VerticalSpacer size="large" />
        <CustomDatePicker
          onSelect={handleDateSelect}
          onClose={handleClose}
          initialDate={initialDate}
        />
      </BottomSheet>
    </>
  );
};
